import { render, staticRenderFns } from "./KeyboardShortcutsModal.vue?vue&type=template&id=7d16af27&"
import script from "./KeyboardShortcutsModal.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutsModal.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcutsModal.vue?vue&type=style&index=0&id=7d16af27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports